import React, { useEffect, useState } from 'react';
import ReactPaginate from 'react-paginate';
import axios from "axios";

function Items({ currentItems }) {

    const [TeterPriceBuy,setTeterPriceBuy] = useState()
    const [TeterPriceSell,setTeterPriceSell] = useState()



    useEffect(() => {
        async function fetchData() {
          // You can await here
          const response =  axios.get('https://api.sinatether.com/Auth/GetTeter').then((res)=>{

            if (res.status==200){
                 setTeterPriceBuy(res.data['teterprice']['buy'])
                 setTeterPriceSell(res.data['teterprice']['sell'])

            }

       });
          // ...
        }
        fetchData();
      }, [])
   

    return (
        <>
    {currentItems && currentItems.map((sym) => (

        
<div className={'row tr_row  py-2 px-1 '}>
<div className={'col-2 '}>
    <a className="pointer linkStyle"
       href={`/${sym['symbol'].split('-')[0]}`}>
        <div className="text-black">
            <img className="imgcoin "
                 src={`https://static.sinatether.com/CoinsImg/${sym['symbol'].split('-')[0]}.png`} alt={""}/>
            <span
                className="spanHeaderAcc">
<span
className="ft-external-link tt0562 text-large">{sym['persionName'].length >=15 ? `${sym['persionName'].slice(0,15)}..`: sym['persionName']}


<span className="text-medium text-muted">{sym['symbol'].split('-')[0]}</span>




</span>

</span>

        </div>
    </a>


</div>
{sym ?
    <>

        <div className={'col-2 '}>
            <div className={'table-hover'}>
                <p className={'text-success m0562 mb-0 '}>{new Intl.NumberFormat("fa",{maximumFractionDigits:sym['BuyIrt'] > 1 ? 3 : 13}).format(sym['BuyIrt'] )} </p>
            </div>

        </div>
        <div className={'col-2 '}>
            <div className={'table-hover'}>
                <p className={'text-danger m0562 mb-0'}> {new Intl.NumberFormat("fa",{maximumFractionDigits:sym['sellIrt'] > 1 ? 3 : 13}).format(sym['sellIrt'] )} </p>
            </div>
        </div>
        <div className={'col-2 '}>
            <div className={'table-hover'}>
                <p className={'priceTt m0562 mb-0'}> {new Intl.NumberFormat("fa",{maximumFractionDigits:sym['sell'] > 1 ? 3 : 13}).format(sym['sell'])}</p>
            </div>
        </div>


        <div class="col-2 pointer text-right text-blue-primery text-large priceTt">
        <p className={'text-normal priceTt mb-0 m0562 pt-1'}>
                                                                {sym['changeRate']>=0 ?
                                                                    <>


                                                                          <svg id="up.0f59dd92" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 16 16">
                                                                          <path id="Path_1" data-name="Path 1" d="M16,0H0V16H16Z" fill="rgba(255,255,255,0.01)"/>
                                                                          <path id="Path_2" data-name="Path 2" d="M13.668,9V5h-4" fill="none" stroke="#29cd97" stroke-width="1.333"/>
                                                                          <path id="Path_3" data-name="Path 3" d="M2,12.333,5.446,8.167l3.282,2L13.667,5" fill="none" stroke="#06a969" stroke-width="1.333"/>
                                                                        </svg>


                                                                <span className={'text-success pl-1'}>
                                                                    {sym['changeRate']}%

                                                                </span>
                                                                          </>

                                                                    :

                                                                    <>






                                                            <svg id="down.75125799" xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 16 16">
                                                              <path id="Path_4" data-name="Path 4" d="M16,16H0V0H16Z" fill="rgba(255,255,255,0.01)"/>
                                                              <path id="Path_5" data-name="Path 5" d="M13.668,7v4h-4" fill="none" stroke="#f5455b" stroke-width="1.333"/>
                                                              <path id="Path_6" data-name="Path 6" d="M2,3.667,5.446,7.833l3.282-2L13.667,11" fill="none" stroke="#f5455b" stroke-width="1.333"/>
                                                            </svg>



                                                                <span className={'text-danger pl-1'}>
                                                                    {-1 * Number(sym['changeRate'])}%

                                                                </span>


                                                                    </>
                                                                }
                                                            </p>



        </div>



    </>
    :
    <>


        
    </>


}


<div className={'col-2 text-left  '}>

    <div
        className=" float-left text-right  px-2 ">

        <div className="col-3 px-1 px---1 btn-size btnnSi">
            <a href={`/${sym['symbol'].split('-')[0]}`}>

                <button
                    className="btn mybtn-ku text-large w-100 py---6 buy mb-0 pointer ng-star-inserted btn-size ">
                    <span className={'text-large text-kuco pr-1 pt-1 pb-1'}>خرید</span>
                    <span className={'text-large text-kuco'}>|</span>
                    <span className={'text-large text-kuco pl-1'}>
                        فروش
                    </span>
                </button>

            </a>

        </div>



    </div>


</div>

</div>
        )

    )
}
        </>
    )}


export default function PaginatedItems({ itemsPerPage ,items,key}) {
  // We start with an empty list of items.

  const [currentItems, setCurrentItems] = useState(null);
  const [pageCount, setPageCount] = useState(0);
  // Here we use item offsets; we could also use page offsets
  // following the API or data you're working with.
  const [itemOffset, setItemOffset] = useState(0);

  useEffect(() => {
    // Fetch items from another resources.
    const endOffset = itemOffset + itemsPerPage;
    console.log(`Loading items from ${itemOffset} to ${endOffset}`);
    setCurrentItems(items.slice(itemOffset, endOffset));
    setPageCount(Math.ceil(items.length / itemsPerPage));
  }, [itemOffset, itemsPerPage]);

  // Invoke when user click to request another page.
  const handlePageClick = (event) => {
    const newOffset = event.selected * itemsPerPage % items.length;
    setItemOffset(newOffset);
  };

  return (
    <>
      <Items currentItems={currentItems} />
      <ReactPaginate
        nextLabel=">>"
        onPageChange={handlePageClick}
        pageRangeDisplayed={3}
        marginPagesDisplayed={2}
        pageCount={pageCount}
        previousLabel="<<"
        pageClassName="page-item"
        pageLinkClassName="page-link"
        previousClassName="page-item"
        previousLinkClassName="page-link"
        nextClassName="page-item"
        nextLinkClassName="page-link"
        breakLabel="..."
        breakClassName="page-item"
        breakLinkClassName="page-link"
        containerClassName="pagination"
        activeClassName="active"
        renderOnZeroPageCount={null}
      />
    </>
  );
}